export default __webpack_public_path__ + "static/media/list-view.inline.723a8de9.svg";